import prettyBytes from 'pretty-bytes';

export const friendlyBytes = size => {
    let parsed = parseInt(size, 0);
    if (isNaN(parsed)) {
        parsed = 0;
    }
    return prettyBytes(parsed, {maximumFractionDigits: 1});
};
